/* Apparelle - Delivery conditional - v4 (locale-aware ES + pt-PT)
   ────────────────────────────────────────────────────────────────
   v4 (19 ago 2026): plazos alineados con el checkout tras medir 515 pedidos.
     - Pen\u00EDnsula y Baleares: 2-3 d\u00EDas laborables (48-72 h).
     - Canarias: 3-4 d\u00EDas laborables (72-96 h). Se avisa en la nota.
     - Portugal / Europa: 3-5 d\u00EDas laborables.
   Config equivalente en Shopify: Estimated delivery dates = Manual,
   preparaci\u00F3n mismo d\u00EDa laborable, tr\u00E1nsito 2-3 d\u00EDas en la zona Espa\u00F1a.
   Reloj de Madrid y solo d\u00EDas laborables (festivos nacionales incluidos).
*/
(function(){
  var HOLIDAYS=['2026-01-01','2026-01-06','2026-04-03','2026-05-01','2026-08-15','2026-10-12','2026-12-08','2026-12-25','2027-01-01','2027-01-06','2027-03-26','2027-05-01','2027-08-15','2027-10-12','2027-11-01','2027-12-06','2027-12-08','2027-12-25'];
  var mAbbr=['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic'];
  var wDay=['domingo','lunes','martes','mi\u00E9rcoles','jueves','viernes','s\u00E1bado'];
  var MIN_DAYS=2, MAX_DAYS=3;
  function isPT(){
    var l=((window.Shopify&&window.Shopify.locale)||document.documentElement.lang||'').toLowerCase();
    return l.indexOf('pt')===0;
  }
  function madrid(){
    var p=new Intl.DateTimeFormat('en-CA',{timeZone:'Europe/Madrid',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',hour12:false}).formatToParts(new Date()).reduce(function(a,x){a[x.type]=x.value;return a;},{});
    return {d:new Date(Date.UTC(+p.year,+p.month-1,+p.day)),h:+(p.hour==='24'?'0':p.hour)};
  }
  function key(d){return d.getUTCFullYear()+'-'+String(d.getUTCMonth()+1).padStart(2,'0')+'-'+String(d.getUTCDate()).padStart(2,'0');}
  function work(d){var w=d.getUTCDay();return w!==0&&w!==6&&HOLIDAYS.indexOf(key(d))===-1;}
  function add(d,n){var x=new Date(d.getTime());while(n>0){x.setUTCDate(x.getUTCDate()+1);if(work(x))n--;}return x;}
  function range(d1,d2){
    if(d1.getUTCMonth()===d2.getUTCMonth())return d1.getUTCDate()+'-'+d2.getUTCDate()+' '+mAbbr[d1.getUTCMonth()];
    return d1.getUTCDate()+' '+mAbbr[d1.getUTCMonth()]+'-'+d2.getUTCDate()+' '+mAbbr[d2.getUTCMonth()];
  }
  function render(el){
    if(!el)return;
    if(isPT()){el.innerHTML='\u2713 Entrega em <strong>3 a 5 dias \u00FAteis</strong>';return;}
    try{
      var now=madrid(), hoy=now.d, salida=hoy;
      if(!work(hoy)||now.h>=14){salida=add(hoy,1);}
      var d1=add(salida,MIN_DAYS), d2=add(salida,MAX_DAYS);
      var dias=Math.round((salida-hoy)/86400000), msg;
      if(dias===0){msg='\u2713 Antes de las <em>14h</em> \u00B7 Recibe <strong>'+range(d1,d2)+'</strong>';}
      else if(dias===1){msg='\u2713 Sale ma\u00F1ana \u00B7 Recibe <strong>'+range(d1,d2)+'</strong>';}
      else{msg='\u2713 Sale el '+wDay[salida.getUTCDay()]+' \u00B7 Recibe <strong>'+range(d1,d2)+'</strong>';}
      msg+=' <span style="opacity:.6">\u00B7 Canarias, 1 d\u00EDa m\u00E1s</span>';
      el.innerHTML=msg;
    }catch(e){}
  }
  function init(){
    var els=document.querySelectorAll('[data-ap-deliv-text]');
    Array.prototype.forEach.call(els,render);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();
